import { Braces, Code, Eye } from 'lucide-react'
import React from 'react'

export default function JsonPreview({jsonError,jsonPreview ,isCurrentFile=false}) {
  return (
     <div className="w-full h-100  mt-4 flex flex-col  border-1 border-gray-500/30 rounded-lg">
                <div className="flex items-center justify-between px-4 py-3 bg-blue-300/10 border-gray-500/30 border-b-1 ">
                  <div className="flex items-center  justify-start space-x-2">
                    {/* icon */}
                    <div class="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center flex-shrink-0">
                      {isCurrentFile?<Braces className="text-white " />:<Eye className="text-white " />}
                    </div>
                    {/* live preview */}
                    <div className="flex flex-col   ">
                      <span className="text-sm font-bold  text-slate-900">
                        {isCurrentFile?"Current Configuration": "Live Preview"}
                      </span>
                      <span className="text-[10px] font-normal font-sans text-slate-900">
                       {isCurrentFile?"Active deeplink setup":"New File Preview"} 
                      </span>
                    </div>
                  </div>
                </div>

                <div className="max-h-70 p-4">
                  <div className="w-full h-full bg-slate-900 dark:bg-slate-200/40 rounded-lg p-4 overflow-auto text-xs">
                    {jsonError && (
                      <span className="text-red-400">{jsonError}</span>
                    )}

                    {jsonPreview && !jsonError && (
                      <pre className="text-green-300 whitespace-pre-wrap">
                        {jsonPreview}
                      </pre>
                    )}
                  </div>
                </div>

                <span className="text-[10px] text-slate-600 font-medium flex items-center justify-start border-t-1 border-gray-500/30 px-4 py-2">
                  ✓ Valid JSON detected. Your deeplink configuration is ready to
                  be uploaded
                </span>
              </div>
  )
}
